export class TaskHoverModel {
  width = 450;
  title: string;
  description: string;
  bottomHoverElement: number;
  LeftHoverElemet: number;
  leftTrianglePosition: number;
}
